// =============================================================================
// features/sales/campaigns/detail/weekday.ts — Rótulos/ordem dos dias da
// semana para o editor de `weeklyWindow` da aba Configuração.
//
// Duplicação DELIBERADA e mínima de `wizard/cadence.ts` (fora de
// `files_allowed` — F35-S08 é dono de `campaigns/wizard/**`, ver frontmatter
// do slot): são só 7 rótulos e uma ordem fixa, não uma lógica de negócio —
// importar de dentro de `wizard/` acoplaria este slot a um diretório
// proibido. `CampaignWeeklyWindowSchema` (a validação real) continua vindo
// de `@elemento/shared-schemas`, fonte única.
// =============================================================================

import type { CampaignWindowDayKey } from '@elemento/shared-schemas';

export const WEEKDAY_ORDER: readonly CampaignWindowDayKey[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
];

export const WEEKDAY_LABEL: Record<CampaignWindowDayKey, string> = {
  mon: 'Segunda',
  tue: 'Terça',
  wed: 'Quarta',
  thu: 'Quinta',
  fri: 'Sexta',
  sat: 'Sábado',
  sun: 'Domingo',
};
